import { useState } from 'react';
import Button from '@raydiant/raydial/components/Button';
import Modal from '@raydiant/raydial/components/Modal';
import TextField from '@raydiant/raydial/components/TextField';
import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';

interface CreateFolderDialogProps {
  isLoading: boolean;
  isOpen: boolean;
  title?: string;
  placeholder?: string;
  onSubmit: (name: string) => void;
  onClose: () => void;
}

const CreateFolderDialog = ({
  isLoading,
  isOpen = false,
  title = 'New folder',
  placeholder = 'Enter folder name',
  onSubmit,
  onClose,
}: CreateFolderDialogProps) => {
  const [name, setName] = useState<string>('');

  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog showCloseButton onClose={() => onClose()}>
        <DialogHeader>
          <DialogHeading>
            <span className="text-black">{title}</span>
          </DialogHeading>
        </DialogHeader>

        <TextField
          value={name || ''}
          onChange={setName}
          placeholder={placeholder}
        />

        <div className="flex flex-col-reverse justify-between mt-8 mb-4 gap-3 px-0 md:gap-6 md:flex-row md:px-4">
          <Button
            onPress={() => onClose()}
            variant="secondary"
            size="large"
            className="grow"
          >
            Cancel
          </Button>
          <Button
            loading={isLoading}
            isDisabled={isLoading || !name}
            onPress={() => onSubmit(name)}
            variant="primary"
            size="large"
            className="grow"
          >
            Create
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
};

export default CreateFolderDialog;
